// extracted by mini-css-extract-plugin
export default {"faqs":"Faqs-module--faqs--tFrId","index":"Faqs-module--index--SJz6I","faq":"Faqs-module--faq--DmvrS","anchor":"Faqs-module--anchor--SLC15"};